"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var GuidService = /** @class */ (function () {
    function GuidService() {
    }
    GuidService.prototype.generate = function () {
        var d = new Date().getTime(); // Timestamp
        var d2 = (performance && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16; // random number between 0 and 16
            if (d > 0) { // Use timestamp until depleted
                // tslint:disable-next-line:no-bitwise
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            }
            else {
                // tslint:disable-next-line:no-bitwise
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            // tslint:disable-next-line:no-bitwise
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    };
    GuidService = __decorate([
        CommonService_decorator_1.CommonService('GuidService')
    ], GuidService);
    return GuidService;
}());
exports.GuidService = GuidService;
//# sourceMappingURL=Guid.service.js.map